import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import noop from 'lodash/noop';

import {
  ExtendedFlex,
} from '../../coreui';

import withPortal from '../../withPortal';
import NetWorthSpecific from '../../dashboard/autoinvest/components/form/NetWorthSpecific';
import {
  sliderMapping,
} from '../../components/isq/utility';

const componentRoot = typeof document !== 'undefined' ? document.getElementById('net-worth-specific-root') : null;
const specificNetWorthName = 'isq[field_specific_net_worth]';

class InvestFlowSpecificNetWorthWithPortal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      netWorthSpecific: null,
      netWorth: null,
    };

    this.jQuery = get(window, 'jQuery', noop);

    // Remove the existing net worth element but also get the default value.
    const netWorthElement = this.jQuery(`:input[name="${specificNetWorthName}"]`);
    if (netWorthElement && netWorthElement.length === 1) {
      const netWorthSpecific = netWorthElement.val();
      netWorthElement.remove();
      if (netWorthSpecific) {
        this.state.netWorthSpecific = netWorthSpecific;
      }
    }

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const netWorthElement = this.jQuery(':input[name="isq[field_investor_net_worth]"]');

    if (netWorthElement && netWorthElement.length === 1) {
      this.setState({
        netWorth: netWorthElement.val(),
      });

      netWorthElement.change(() => {
        const netWorth = netWorthElement.val();
        this.setState(({
          netWorth: oldNetWorth,
        }) => ({
          netWorth,
          ...(netWorth !== oldNetWorth ? { netWorthSpecific: null } : {}),
        }));
      });
    }
  }

  handleChange(e) {
    this.setState({
      netWorthSpecific: e.target.value,
    });
  }

  render() {
    const {
      netWorthSpecific,
      netWorth,
    } = this.state;

    const {
      sliderMapping: {
        [this.state.netWorth]: {
          min = null,
        } = {},
      },
    } = this.props;

    if (min === null) {
      return null;
    }

    return (
      <ExtendedFlex
        flexDirection="column"
      >
        <div
          className="merlin-font-h6 isq-accred-title"
        >
          Please specify your net worth within this range:
        </div>
        <NetWorthSpecific
          name={specificNetWorthName}
          value={netWorthSpecific}
          netWorth={netWorth}
          onChange={this.handleChange}
        />
      </ExtendedFlex>
    );
  }
}

InvestFlowSpecificNetWorthWithPortal.propTypes = {
  sliderMapping: PropTypes.object,
};

InvestFlowSpecificNetWorthWithPortal.defaultProps = {
  sliderMapping,
};

export default withPortal(
  InvestFlowSpecificNetWorthWithPortal,
  componentRoot,
  {
    noRootNoRender: true,
  },
);
